interface Props {
  color: string;
  selected: boolean;
  disabled: boolean;
  toggleOption: () => void;
  isProductBox?: boolean;
  /** Sold out variant: stays visible, but is marked and (usually) not selectable. */
  outOfStock?: boolean;
}
const SvgColorOption: React.FC<Props> = ({
  color,
  selected,
  disabled,
  toggleOption,
  isProductBox,
  outOfStock,
}) => {
  const dim = isProductBox ? 16 : 32;
  const notAvailable = disabled || !!outOfStock;
  return (
    <svg
      style={{ cursor: notAvailable ? "not-allowed" : "pointer" }}
      onClick={disabled ? undefined : toggleOption}
      aria-disabled={disabled || undefined}
      width={dim}
      height={dim}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="16"
        cy="16"
        r={notAvailable ? "15.5" : "15"}
        fill={color}
        className={`${selected ? "stroke-primary" : "stroke-gray4"}${
          notAvailable ? " color-option-unavailable" : ""
        }`}
        fillOpacity={notAvailable ? "0.1" : "1"}
        strokeWidth={notAvailable ? "1" : "2"}
      />
      {notAvailable && (
        <line
          x1="5.35355"
          y1="4.64645"
          x2="27.3536"
          y2="26.6464"
          className="stroke-gray4"
        />
      )}
    </svg>
  );
};

export default SvgColorOption;
